"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _colors = require("HubStyleTokens/colors");

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _decorators = require("../utils/propTypes/decorators");

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var _UIDragHandle = _interopRequireDefault(require("./UIDragHandle"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var _Styles = require("../utils/Styles");

var _sizes = require("HubStyleTokens/sizes");

var _theme = require("HubStyleTokens/theme");

var _Color = require("../core/Color");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 30px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  top: 16px;\n  margin-right: -12px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  ", "\n  ", ";\n  font-size: ", ";\n  background-color: ", ";\n\n  ", "\n\n  .private-moveable-object + & {\n    margin-top: 12px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  box-shadow: 0 0 12px 0 ", ";\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var draggingMixin = (0, _styledComponents.css)(_templateObject(), (0, _Styles.setGrabCursor)('grabbing'), (0, _Color.rgba)(_theme.MONOLITH, 0.1), _sizes.JUPITER_LAYER);

var Outer = _styledComponents.default.div.withConfig({
  displayName: "UIMoveableObject__Outer",
  componentId: "sc-1u12jva-0"
})(_templateObject2(), (0, _Styles.setInputAppearance)(), (0, _Styles.setInputMetrics)(parseInt(_sizes.INPUT_DEFAULT_PADDING_Y, 10) - 1, 26, 30), _sizes.BASE_FONT_SIZE, function (_ref) {
  var use = _ref.use;
  return use === 'on-dark' ? _theme.OLAF : _colors.KOALA;
}, function (_ref2) {
  var isDragging = _ref2.isDragging;
  return isDragging && draggingMixin;
});

var CloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "UIMoveableObject__CloseButton",
  componentId: "sc-1u12jva-1"
})(_templateObject3());

var TooltipAnchor = _styledComponents.default.span.withConfig({
  displayName: "UIMoveableObject__TooltipAnchor",
  componentId: "sc-1u12jva-2"
})(_templateObject4());

var UIMoveableObject = _react.default.createClass({
  displayName: "UIMoveableObject",
  propTypes: {
    children: _react.PropTypes.node.isRequired,
    closeable: _react.PropTypes.bool.isRequired,
    closeDisabledMessage: _react.PropTypes.string,
    draggable: _react.PropTypes.bool.isRequired,
    isCloseDisabled: _react.PropTypes.bool.isRequired,
    isDragging: _react.PropTypes.bool.isRequired,
    onClose: _react.PropTypes.func,
    dragHandle: (0, _decorators.hidden)(RenderProp.getPropType(_UIDragHandle.default)),
    DragHandle: RenderProp.getPropType(_UIDragHandle.default).isRequired,
    truncate: (0, _decorators.hidden)(_react.PropTypes.bool),
    use: _react.PropTypes.oneOf(['default', 'on-dark'])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      closeable: true,
      draggable: true,
      isCloseDisabled: false,
      isDragging: false,
      DragHandle: _UIDragHandle.default,
      truncate: true,
      use: 'default'
    };
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        closeable = _this$props.closeable,
        closeDisabledMessage = _this$props.closeDisabledMessage,
        draggable = _this$props.draggable,
        isCloseDisabled = _this$props.isCloseDisabled,
        dragHandle = _this$props.dragHandle,
        DragHandle = _this$props.DragHandle,
        onClose = _this$props.onClose,
        truncate = _this$props.truncate,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "closeable", "closeDisabledMessage", "draggable", "isCloseDisabled", "dragHandle", "DragHandle", "onClose", "truncate"]);
    var content = truncate ? _react.default.createElement(_UITruncateString.default, null, children) : children;

    var renderedChildren = _react.default.createElement(Outer, (0, _extends2.default)({}, rest, {
      className: (0, _classNames.default)('private-moveable-object', className)
    }), content, closeable && _react.default.createElement(_UITooltip.default, {
      title: closeDisabledMessage
    }, _react.default.createElement(TooltipAnchor, null, _react.default.createElement(CloseButton, {
      color: _colors.EERIE,
      disabled: isCloseDisabled,
      onClick: onClose,
      size: "small"
    }))));

    if (draggable) {
      var ComputedDragHandle = dragHandle || DragHandle;
      return _react.default.createElement(ComputedDragHandle, null, renderedChildren);
    }

    return renderedChildren;
  }
});

var _default = UIMoveableObject;
exports.default = _default;
module.exports = exports.default;